module.exports = __webpack_public_path__ + "assets/img/27_1286.d9d81407.jpg";